/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Snap_To_Event_Start_FailedInputs */



/**
* | output |
* | --- |
* | "Snap to event start failed with message: {error}" |
*
* @param {Snap_To_Event_Start_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_event_start_failed = /** @type {((inputs: Snap_To_Event_Start_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Event_Start_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Alignement sur le début des événements échoué : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Snap zum Starten des Ereignisses fehlgeschlagen mit der Meldung: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Scatto all'avvio dell'evento non riuscito con messaggio: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Сбой привязки к началу события с сообщением: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al iniciar el evento de ajuste con el mensaje: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`捕捉到事件开始失败，错误信息：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント開始へのスナップが失敗しました。メッセージ: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्नैप टू इवेंट स्टार्ट विफल रहा, संदेश के साथ: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A sincronização com o início do evento falhou com a mensagem: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Snap to event start failed with message: ${i?.error}`)
});